const PartStatus = {
  10: {
    key: "PENDING",
    label: "Procesando Pedido",
    color: "is-grey",
  },
  20: {
    key: "PLACED",
    label: "Procesando Pedido",
    color: "is-grey",
  },
  30: {
    key: "IN_TRANSIT",
    label: "En Tránsito",
    color: "is-grey",
  },
  31: {
    key: "RECEIVED_IN_CUSTOMS",
    label: "Recibido en Aduana",
    color: "is-grey",
  },
  40: {
    key: "RECEIVED",
    label: "Recibido en Suc. Destino",
    color: "is-grey",
  },
  50: {
    key: "READY",
    label: "Listo para Entrega",
    color: "is-success",
  },
  60: {
    key: "SENT_TO_CUSTOMER",
    label: "Enviado al cliente",
    color: "is-grey",
  },
  70: {
    key: "DELIVERED",
    label: "Entregado",
    color: "is-success",
  },
  80: {
    key: "CANCELED",
    label: "Cancelado",
    color: "is-danger",
  },
};

const PartStatusList = [
  {
    id: 10,
    key: "PENDING",
    label: "Procesando Pedido",
    color: "is-grey",
  },
  {
    id: 20,
    key: "PLACED",
    label: "Pedido Colocado",
    color: "is-grey",
  },
  {
    id: 30,
    key: "IN_TRANSIT",
    label: "En Tránsito",
    color: "is-primary",
  },
  {
    id: 31,
    key: "RECEIVED_IN_CUSTOMS",
    label: "Recibido en Aduana",
    color: "is-primary",
  },
  {
    id: 40,
    key: "RECEIVED",
    label: "Recibido en Suc. Destino",
    color: "is-primary",
  },
  {
    id: 50,
    key: "READY",
    label: "Listo para Entrega",
    color: "is-success",
  },
  {
    id: 60,
    key: "SENT_TO_CUSTOMER",
    label: "Enviado al cliente",
    color: "is-success",
  },
  {
    id: 70,
    key: "DELIVERED",
    label: "Entregado",
    color: "is-success",
  },
  {
    id: 80,
    key: "CANCELED",
    label: "Cancelado",
    color: "is-danger",
  },
];

export { PartStatus, PartStatusList };
